module.exports = __webpack_public_path__ + "files/4e66171dd4b05faee07acf3bb452d5fe.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/exo2-italic-webfont.ttf
// module id = 675
// module chunks = 60